// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  // console.log("@@beginCheckout", event.detail);
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  // GOOGLE ADS BEGIN CHECKOUT EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11302531515");
  window.gtag("event", "begin_checkout", {
    send_to: ["AW-11302531515/6m3iCL-qwY8ZELvju40q", "G-VV2XBZ9C9S"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
  });

  // GOOGLE ADS BEGIN CHECKOUT EVENT CODE END
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  // console.log("@@paymentInfo", event.detail);
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
  // GOOGLE ADS PAYMENT INFO EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11302531515");
  window.gtag("event", "add_payment_info", {
    send_to: ["AW-11302531515/dPjRCMKqwY8ZELvju40q", "G-VV2XBZ9C9S"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
  });
  // GOOGLE ADS ADD PAYMENT INFO EVENT CODE END
}

// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------

//----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  // console.log("@@purchase", event.detail);
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11302531515");
  window.gtag("event", "purchase", {
    send_to: ["AW-11302531515/utufCKSnwY8ZELvju40q", "G-VV2XBZ9C9S"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    items: params.items,
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}
//----------------- END PURCHASE SCRIPT --------------------------------------
